import {
  Button,
  ButtonType,
  Modal,
  Size,
  TextField,
  TextFieldType,
  Typography,
  TypographySize,
  TypographyWeight
} from '~/components/core';
import { CopyButton } from '~/components/shared';

interface ApiKeyModalProps {
  apiKey: string;
  header: string;
  onConfirm: () => void;
  open: boolean;
  subtext: string;
}

const ApiKeyModal: React.FC<ApiKeyModalProps> = ({
  open,
  header,
  subtext,
  onConfirm,
  apiKey
}) => (
  <Modal open={open}>
    <div
      className="flex flex-col items-center justify-between gap-6"
      data-testid="api-key-modal-container"
    >
      <div
        className="flex flex-col items-center justify-center gap-2"
        data-testid="header-subtext-container"
      >
        <Typography
          size={TypographySize.H4}
          weight={TypographyWeight.SEMI_BOLD}
        >
          {header}
        </Typography>
        {subtext && <Typography>{subtext}</Typography>}
      </div>
      <div
        className="flex w-full flex-row items-center justify-center gap-2"
        data-testid="api-key-copy-container"
      >
        <TextField
          fullWidth
          onChange={() => {}}
          type={TextFieldType.HIGHLIGHT}
          value={apiKey}
        />
        <CopyButton size={Size.SMALL} text={apiKey} />
      </div>
      <div
        className="flex w-full items-center justify-end gap-2"
        data-testid="buttons-container"
      >
        <Button label="Done" onClick={onConfirm} type={ButtonType.SOLID} />
      </div>
    </div>
  </Modal>
);

export default ApiKeyModal;
